import { Route, Routes } from "react-router-dom";
import Landing from "./pages/Landing";
import QuizRegistration from "./pages/QuizRegistration";
import OtpVerify from "./pages/OtpVerify";
import IdUpload from "./pages/IdUpload";
import Instructions from "./pages/Instructions";
import Attempt from "./pages/Attempt";
import Result from "./pages/Result";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminHome from "./pages/admin/AdminHome";
import AdminCategories from "./pages/admin/AdminCategories";
import AdminCandidates from "./pages/admin/AdminCandidates";
import AdminQuestionsList from "./pages/admin/AdminQuestionsList";
import AdminQuestionEditor from "./pages/admin/AdminQuestionEditor";
import AdminQuestionsImport from "./pages/admin/AdminQuestionsImport";
import AdminQuizzesList from "./pages/admin/AdminQuizzesList";
import AdminQuizEditor from "./pages/admin/AdminQuizEditor";
import AdminQuizResults from "./pages/admin/AdminQuizResults";
import AdminAttemptDetail from "./pages/admin/AdminAttemptDetail";
import AdminAuditLog from "./pages/admin/AdminAuditLog";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminUsers from "./pages/admin/AdminUsers";
import ChangePassword from "./pages/admin/ChangePassword";
import ForgotPassword from "./pages/admin/ForgotPassword";
import ResetPassword from "./pages/admin/ResetPassword";
import { PoweredBy } from "./components/PoweredBy";
import NotFound from "./pages/NotFound";

export default function App() {
  return (
    <>
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/quiz/:quizId" element={<QuizRegistration />} />
      <Route path="/quiz/:quizId/verify" element={<OtpVerify />} />
      <Route path="/quiz/:quizId/id-upload" element={<IdUpload />} />
      <Route path="/quiz/:quizId/instructions" element={<Instructions />} />
      <Route path="/quiz/:quizId/attempt/:attemptId" element={<Attempt />} />
      <Route path="/quiz/:quizId/result/:attemptId" element={<Result />} />

      {/* Admin */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/forgot-password" element={<ForgotPassword />} />
      <Route path="/admin/reset-password" element={<ResetPassword />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminHome />} />
        <Route path="categories" element={<AdminCategories />} />
        <Route path="candidates" element={<AdminCandidates />} />
        <Route path="questions" element={<AdminQuestionsList />} />
        <Route path="questions/new" element={<AdminQuestionEditor />} />
        <Route path="questions/import" element={<AdminQuestionsImport />} />
        <Route path="questions/:questionId" element={<AdminQuestionEditor />} />
        <Route path="quizzes" element={<AdminQuizzesList />} />
        <Route path="quizzes/new" element={<AdminQuizEditor />} />
        <Route path="quizzes/:quizId" element={<AdminQuizEditor />} />
        <Route path="quizzes/:quizId/results" element={<AdminQuizResults />} />
        <Route path="attempts/:attemptId" element={<AdminAttemptDetail />} />
        <Route path="audit-log" element={<AdminAuditLog />} />
        <Route path="settings" element={<AdminSettings />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="change-password" element={<ChangePassword />} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
    <PoweredBy />
    </>
  );
}
